import React, { Component } from 'react'
import Header from '@/components/Header'
import MetaDetail from '../../components/_common/MetaDetail'
import Form from "@/components/_common/Form";
import TextField from "@/components/_common/Form/inputs/TextField";
import Dob from "@/components/_common/Form/inputs/Dob";
import Select from "@/components/_common/Form/inputs/Select";
//import Checkbox from "#/components/_common/Form/inputs/Checkbox";
import tracking from '../../utils/tracking'
import './theuselessbrew.scss'
import countries from "@/data/countries.json";
import validateForm from "@/components/_common/Form/validate";
import TextArea from '../../components/_common/Form/inputs/TextArea';
import Checkbox from "@/components/_common/Form/inputs/Checkbox";
import { post } from "@/utils/api";
import Image from './images/uselessbrew-image1.jpg';
// import TaC from "./images/useless-brew-terms-and-conditions.pdf";


class TheUselessBrewPage extends Component {
	state = {
		fields: {
		  first_name: { value: "", showError: false },
		  last_name: { value: "", showError: false },
		  email: { value: "", showError: false },
		  country: { value: "IE", showError: false },
		  dob: { day: "", month: "", year: "", showError: false },
		  paragraph:{value:"",showError:false,limit:500},
		  terms_of_use:{value:false,showError:false},
		  subscribe_brand_news_optional:{value:false,showError:false}
		},
		submitSuccess:false
	  };

	  
	// onPDFClick() {
	// 	window.open(TaC);
	// }

	componentDidMount() {
		tracking.pageView('/theuselessbrew')
	}

	onFormChange = (value, name, key = "value") => {
		if(name!="country"){
			this.setState(state => (state.fields[name][key] = value));
		}
		
	};

	onSubmit = async () => {
		
		
	
		const { fields } = this.state;
		
		const data = {};
	
		Object.keys(fields).forEach(key => {
			data[key] = fields[key].value || (key == "subscribe_brand_news_optional" ? false : "")
		});
		
		

		data.dob = `${fields.dob.year}-${fields.dob.month}-${fields.dob.day}`;
		data.promocode = "DGL000OGB1220WC0002"

		try {
			const response = await post(data, "submit-comp");
			console.log(response);
			if (response.error) {
				if (response.error === "under_18") {
						tracking.event("customEvent", {
							eventCategory: "Sign Up Form",
							eventAction: "error",
							eventLabel: `under 18, source: ${
							this.props.routeProps.location.pathname
						}`
					});
					return alert("You must be 18 or over");
				}
		
				tracking.event("customEvent", {
				eventCategory: "Sign Up Form",
				eventAction: "error",
				eventLabel: `${response.error}, source: ${
					this.props.routeProps.location.pathname
				}`
				});
				return alert(response.error);
			  }
			  tracking.event("customEvent", {
				eventCategory: "Useless brew submit success",
				eventAction: "submit"
				})
			  //Success 
			  this.setState({submitSuccess:true});
	
		} catch (e) {
		  tracking.event("customEvent", {
			eventCategory: "Sign Up Form",
			eventAction: "error",
			eventLabel: `${e}, source: ${this.props.routeProps.location.pathname}`
		  });
		  alert(e);
		  console.error(e);
		}
	  };

	  
	render() {

		let items = [

			{
				image:Image,
				header: 'SO, WHAT’S THIS BREW ALL ABOUT? ',
				copy: `<div>
					<p>We reached out to our friends at The Useless Project to launch ‘The UseLess Brew’, a sustainable, waste busting beer. </p>
					<p>Bread is the most wasted food on our planet, with over 240 million slices being thrown out each year. Having been supplied leftover Rye and Buckwheat loaves from organic, Dublin bakery, Bread 41, our brewers got to work to show how unwanted food can be given a new lease of life.  </p>
					
				</div>`,
				color: "blue",
				copyBottom:'Fancy trying this exciting beer out? The UseLess Brew will be available on tap for a limited time only so be sure to <a href="https://www.opentable.ie/r/guinness-open-gate-brewery-reservations-dublin?restref=213819&lang=en-IE&ot_source=Restaurant%20website">book a table</a> in our taproom or outdoor snugs. ',
				list:[]
			},
			{
				header: 'WHAT’S INCLUDED IN THE PRIZE?',
				color: "red",
				copy: "You can be in with a chance to win:",
				list:['2 x limited edition cans of \'<b>The Useless Brew</b>\'','A fresh loaf of bread from Bread 41.',"A guide on tips and tricks on how to upcycle."],
				copyBottom:'Did we mention it all comes in a gorgeous sustainable box? Nothing will go to waste.'
			},
		]
		return (
			<div className='welcome' >
				<Header />
				<div className='welcome-page'>
					{/* <MetaDetail  /> */}
					<div className={'hero hero--active'}>
						<div className={'feature feature--active'}>
							<div className={'hero__container'}>
								<div className={'hero__background'} />
								<div className={'hero__heading-container'} style={{marginTop:'500px'}}>
									<div className={'hero__text-container sweepstakes-heading-container'}>
										<h1 className={'hero__subhead sweepstakes-subhead'}>COMPETITION CLOSED<br/><br/></h1>
										<p className={'hero__subhead'}>This competition has ended. Winners will be contacted shortly.</p>
									</div>
								</div>
							</div>
						</div>
						<div className='hero--waves' />
					</div>
					{items && items.map((item, i) => {
						return (
							<div className={'feature feature--active welcome__container'}>
								<div className={`welcome-item__wrap ${i % 2 === 0 ? 'image-right' : 'image-left'} welcome-item__bg--${item.color}`}>
									<div className={'welcome-item__text-container'}>

										
										<h2 className={'welcome-item__name'}>{item.header}</h2>
										
										
										<div className={'welcome-item__separator'} />
										
										<div className={'welcome-item__desc'} dangerouslySetInnerHTML={{__html: item.copy}} />
										<img src={item.image} style={{marginTop:'15px'}}/>
										<ul style={{listStyleType:'none',margin:'0 35px 0 0'}}>
											{item.list.map((listItem)=>{
												return<li dangerouslySetInnerHTML={{__html:listItem}}/>
											})}
										</ul>
										<div className={'welcome-item__desc-bottom'} style={{marginTop:'40px'}} dangerouslySetInnerHTML={{__html: item.copyBottom}} />
									</div>
									{/* <div className={'welcome-item__image-container'} style={`background-image: url('${item.img}'); background-position: center; background-repeat: no-repeat; background-size: cover`} /> */}
								</div>
							</div>

						)
					})
					}
						
						
				</div>
			</div >
		)
	}
}

// 	export default connect(
//   () => ({}),
// 	{buildContentAction}
// ) (WelcomePage);
export default TheUselessBrewPage



// WEBPACK FOOTER //
// ./src/pages/theuselessbrew/index.js